module.exports = __webpack_public_path__ + "static/img/6454_phase_function_Paper_PointsHejduk_Prediction.1e4709d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6454_phase_function_Paper_PointsHejduk_Prediction.png
// module id = I9FY
// module chunks = 0